import React from "react"
import { withRouter } from "react-router-dom"
import useCommentsLoad from "@components/content-feed/util/hooks/useCommentsLoad";
import { splitId } from "@components/content-feed/admin/manager"
import { SocialButtons } from "./SocialButtons"

export default withRouter(
  ({
    social_buttons = null,
    id,
    teaserId,
    AGG_LIKE,
    view_action,
    detailId,
    history,
    detail_asset_id,
  }) => {
    const handleCommentsLoad = useCommentsLoad(
      view_action,
      detailId,
      history,
      detail_asset_id,
      id,
      teaserId
    )

    return (
      social_buttons &&
      social_buttons.length > 0 && (
        <SocialButtons
          id={id}
          teaserId={splitId(teaserId)}
          buttons={social_buttons}
          AGG_LIKE={AGG_LIKE}
          commentProps={{
            onLoad: handleCommentsLoad,
            filter: handleCommentsLoad && { top: true },
          }}
        />
      )
    )
  }
)
